import React, { useEffect } from 'react';

interface ArchivePlan {
    year: string;
    title: string;
    link: string;
}

interface TableHeaders {
    year: string;
    title: string;
    download: string;
}

interface ArchivePlansModalProps {
    isOpen: boolean;
    onClose: () => void;
    plans: ArchivePlan[];
    title?: string;
    tableHeaders?: TableHeaders;
}

const ArchivePlansModal: React.FC<ArchivePlansModalProps> = ({
    isOpen,
    onClose,
    plans,
    title = "Previous Action Plans",
    tableHeaders = { year: "Year", title: "Title", download: "Download" }
}) => {
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }

        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="rf-digitalmat-overlay" onClick={handleOverlayClick}>
            <div className="rf-digitalmat-overlay-content" style={{ maxWidth: '600px' }}>
                <button
                    className="rf-digitalmat-overlay-close"
                    onClick={onClose}
                    aria-label="Close"
                >
                    ✕
                </button>
                <div className="rf-digitalmat-overlay-header">
                    <h2>{title}</h2>
                </div>
                <div className="rf-digitalmat-contentsection" style={{ padding: '10px 0' }}>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginTop: '10px'
                    }}>
                        <thead>
                            <tr style={{
                                borderBottom: '2px solid #e0e0e0',
                                textAlign: 'left'
                            }}>
                                <th style={{ padding: '12px 8px', fontWeight: 600, color: '#1d1d1f' }}>{tableHeaders.year}</th>
                                <th style={{ padding: '12px 8px', fontWeight: 600, color: '#1d1d1f' }}>{tableHeaders.title}</th>
                                <th style={{ padding: '12px 8px', fontWeight: 600, color: '#1d1d1f', textAlign: 'center' }}>{tableHeaders.download}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {plans.map((plan, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        borderBottom: '1px solid #e0e0e0'
                                    }}
                                >
                                    <td style={{ padding: '14px 8px', color: '#333' }}>{plan.year}</td>
                                    <td style={{ padding: '14px 8px', color: '#333' }}>{plan.title}</td>
                                    <td style={{ padding: '14px 8px', textAlign: 'center' }}>
                                        <a
                                            href={plan.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="button-left-icon w-inline-block"
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '8px 16px',
                                                fontSize: '14px'
                                            }}
                                        >
                                            <div className="button-icon-left" style={{ width: '16px', height: '16px' }}></div>
                                            <span>{tableHeaders.download}</span>
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ArchivePlansModal;



